import React, { useEffect, useRef } from 'react';
import {
  RestaurantDetails_fetchRestaurantRecommendations,
  RestaurantDetails_getRestaurantDetails
} from '../../../../../types/graphql-types-generated.ts';
import { RecommendedRestaurant } from '../../00-atoms/recommended-restaurant/recommended-restaurant.tsx';
import { useHiddenScrollbar } from '../../../../../patterns/01-molecules/hidden-scrollbar/hidden-scrollbar.tsx';
import { UBTracking } from '../../../../../components/tracking/ubtracking.ts';
import { classList } from '../../../../../utils/string.ts';
import { Cookie } from '../../../../../utils/cookie.ts';

export type RecommendedRestaurantsProps = {
  restaurantDetails: RestaurantDetails_getRestaurantDetails;
  recommendations: RestaurantDetails_fetchRestaurantRecommendations[];
};

const recommendedRestaurant = (
  recommendation: RestaurantDetails_fetchRestaurantRecommendations
) => <RecommendedRestaurant key={recommendation.id} recommendation={recommendation} />;

export const RecommendedRestaurants: React.FunctionComponent<
  RecommendedRestaurantsProps
> = props => {
  const hiddenScrollbar = useHiddenScrollbar({
    renderArrows: true,
    renderDots: 'none',
    scrollRange: 'elementWise',
    scrollRotation: false,
    startAtSlide: 0,
    containerType: 'div',
    className: 'flex snap-x overflow-y-scroll pb-7 [&::-webkit-scrollbar]:h-0',
    children: <>{props.recommendations.map(recommendedRestaurant)}</>
  });
  const abTabSetup = new Cookie('sk-AB-tabsetup').value ?? '0';
  const recommendedRestaurantsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (recommendedRestaurantsRef.current) {
      UBTracking.onTrackTargetView(
        recommendedRestaurantsRef.current,
        'scroll_depth',
        'recommended_restaurants'
      );
    }
  }, [recommendedRestaurantsRef]);

  return (
    <div
      ref={recommendedRestaurantsRef}
      className={classList(
        'text-sk-dark-blue border-sk-grey-200 border-t-4 bg-white pt-8 pb-1',
        abTabSetup === '4' && 'md:px-4'
      )}
    >
      <div className="mx-4 mb-4 text-2xl/8 font-extrabold">
        Entdecke mehr in {props.restaurantDetails.linkedCity.name}
      </div>
      {hiddenScrollbar.mainElement}
    </div>
  );
};
